import { observer } from 'mobx-react-lite'
import React, { useContext, useMemo } from 'react'
import { SharedCampaignContext } from '../../../../../../contexts/Advertiser/SharedCampaignContext'
import { separateThousands, currencyFormat } from '../../../../../../utils/Helper'

export default observer(function ShowAll({ selectedScenario }) {
  const { campaignReport } = useContext(SharedCampaignContext)
  const actualInfAmount = useMemo(() => [...new Set(selectedScenario?.actions.map(action => action.influencer_id))].length, selectedScenario?.actions)
  const grossReach = useMemo(() => selectedScenario?.actions.reduce((result, action) => result + action.reach, 0))
  const netReach = useMemo(() => selectedScenario?.actions.reduce((result, action) => result + action.action_insight?.reach, 0))
  const impression = useMemo(() => selectedScenario?.actions.reduce((result, action) => result + (action?.action_insight?.impressions || action?.action_insight?.story_first_sequence_impressions || 0), 0))
  const totalAdvertiserPrice = useMemo(() => selectedScenario?.actions.reduce((result, action) => result + action.totalAdvertiserPrice, 0))
  const socialAdsSpend = useMemo(() => Number(campaignReport?.paid_spend_overview) || 0, [campaignReport?.paid_spend_overview])
  
  return (
    <div className="mb-8">
      <table className="w-full rounded-t-lg overflow-hidden bg-white dark:bg-rb-dark-mode border-separate border-spacing-0 border-t border-r border-l border-b border-border-primary dark:border-rb-dark-mode-lighter">
        <thead>
          <tr>
            <th className="w-1/3 bg-rb-grey dark:bg-rb-dark-mode-lighter border border-border-primary dark:border-rb-dark-mode-lighter"></th>
            <th className="w-1/3 bg-rb-grey dark:bg-rb-dark-mode-lighter text-left font-normal py-4 px-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-white">Goal</th>
            <th className="w-1/3 bg-rb-grey dark:bg-rb-dark-mode-lighter text-left font-normal py-4 px-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-white">Actual</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="text-sm font-bold p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-white">Amount of influencers</td>
            <td className="border border-border-primary dark:border-rb-dark-mode-lighter p-2 align-middle dark:text-white">
              {separateThousands(campaignReport.influencer_amount)}
            </td>
            <td className="border border-border-primary dark:border-rb-dark-mode-lighter p-2 align-middle dark:text-white">
              {separateThousands(actualInfAmount)}
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-white">Reasoning - Amount of influencers</td>
            <td className="p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-gray-400" colSpan="2">
              {campaignReport.influencer_amount_reason}
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-white">Amount of uploads</td>
            <td className="border border-border-primary dark:border-rb-dark-mode-lighter p-2 align-middle dark:text-white">
              {separateThousands(campaignReport.upload_amount)}
            </td>
            <td className="border border-border-primary dark:border-rb-dark-mode-lighter p-2 align-middle dark:text-white">
              {selectedScenario?.actions?.length}
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-white">Reasoning - Amount of uploads</td>
            <td className="p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-gray-400" colSpan="2">
              {campaignReport.upload_amount_reason}
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-white">Gross reach</td>
            <td className="border border-border-primary dark:border-rb-dark-mode-lighter p-2 align-middle dark:text-white">
              {separateThousands(campaignReport.gross_reach)}
            </td>
            <td className="border border-border-primary dark:border-rb-dark-mode-lighter p-2 align-middle dark:text-white">
              {grossReach && separateThousands(grossReach)}
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-white">Reasoning - Gross reach</td>
            <td className="p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-gray-400" colSpan="2">
              {campaignReport.gross_reach_reason}
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-white">Net reach</td>
            <td className="border border-border-primary dark:border-rb-dark-mode-lighter p-2 align-middle dark:text-white">
              {separateThousands(campaignReport.net_reach)}
            </td>
            <td className="border border-border-primary dark:border-rb-dark-mode-lighter p-2 align-middle dark:text-white">
              {netReach && separateThousands(netReach)}
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-white">Reasoning - Net reach</td>
            <td className="p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-gray-400" colSpan="2">
              {campaignReport.net_reach_reason}
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-white">Impressions</td>
            <td className="border border-border-primary dark:border-rb-dark-mode-lighter p-2 align-middle dark:text-white">
              {separateThousands(campaignReport.impression)}
            </td>
            <td className="border border-border-primary dark:border-rb-dark-mode-lighter p-2 align-middle dark:text-white">
              {impression && separateThousands(impression)}
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-white">Reasoning - Impressions</td>
            <td className="p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-gray-400" colSpan="2">
              {campaignReport.impression_reason}
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-white">Influencer budget</td>
            <td className="border border-border-primary dark:border-rb-dark-mode-lighter p-2 align-middle dark:text-white">
              {currencyFormat(campaignReport.influencer_budget, '€')}
            </td>
            <td className="border border-border-primary dark:border-rb-dark-mode-lighter p-2 align-middle dark:text-white">
              {totalAdvertiserPrice && currencyFormat(totalAdvertiserPrice.toFixed(2), '€')}
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-white">Reasoning - Influencer budget</td>
            <td className="p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-gray-400" colSpan="2">
              {campaignReport.influencer_budget_reason}
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-white">Social ads budget</td>
            <td className="border border-border-primary dark:border-rb-dark-mode-lighter p-2 align-middle dark:text-white">
              {currencyFormat(campaignReport.social_ads_budget, '€')}
            </td>
            <td className="border border-border-primary dark:border-rb-dark-mode-lighter p-2 align-middle dark:text-white">
              {currencyFormat(socialAdsSpend.toFixed(2), '€')}
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-white">Reasoning - Social ads budget</td>
            <td className="p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-gray-400" colSpan="2">
              {campaignReport.social_ads_budget_reason}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
})